module.exports = __webpack_public_path__ + "static/media/itakalogo.9eb69e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/itakalogo.png
// module id = 402
// module chunks = 0